/**
 * This can be turned into a more complex solution once we'll want to ask user
 * to enable local storage for a better experience.
 */

import { logErrorsToUiStore } from "@/lib/wordpress/data";

/**
 * In addition to generic local storage unavailability due to browser security
 * settings, writing may also fail if the storage is full (limit is ~5MB as per spec).
 * We don't generally expect this to happen with a significant frequence due to
 * our local storage usage scenario, we don't write that much data there.
 */
export function writeToLocalStorage(key: string, value: string): boolean {
  if (!("localStorage" in window)) {
    return false;
  }

  try {
    // This is the only place in the project where localStorage.setItem is allowed
    // eslint-disable-next-line no-restricted-properties
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    logErrorsToUiStore([
      {
        msg: `Failed to write "${key}" to the local storage. Check console.`
      }
    ]);
    console.error(`Failed to write "${key}" to the local storage`, e);
    return false;
  }
}

export function readFromLocalStorage(key: string): string | null | false {
  if (!("localStorage" in window)) {
    return false;
  }

  try {
    // This is the only place in the project where localStorage.getItem is allowed
    // eslint-disable-next-line no-restricted-properties
    return window.localStorage.getItem(key);
  } catch (e) {
    logErrorsToUiStore([
      {
        msg: `Failed to read "${key}" from the local storage. Check console.`
      }
    ]);
    console.error(`Failed to read "${key}" from the local storage`, e);
    return false;
  }
}
